"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var eventConstants = {
  SKU_NOT_SELECTED_EVENT: 'jl.emailMe.skuNotSelected'
};
var _default = exports.default = eventConstants;